import { ReactElement } from 'react';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';
import { useFormikContext } from 'formik';
import uniqueId from 'lodash/uniqueId';

// Types
import { IFacetProps, SearchRequest } from 'components/ContinuousImprovement/Facets/types';
import { FormikInputField } from 'components/ContinuousImprovement/PureFormElements';

export const TextInput = (props: IFacetProps): ReactElement => {
  const { callback, facet, isDisabled, isExpanded, expandIcon, onToggleExpand } = props;
  const { setFieldValue } = useFormikContext<SearchRequest>();
  const { displayValue, payloadValue } = facet;

  const onKeyPress = (e): void => {
    const value = e.target.value;
    setFieldValue(payloadValue, value);

    // Clicking the enter button should call the callback.
    if (e.which === 13) {
      callback?.();
    }
  };

  return (
    <StyledAccordion key={displayValue} expanded={isExpanded} onChange={onToggleExpand}>
      <StyledAccordionSummary expandIcon={expandIcon} id={uniqueId()}>
        {displayValue}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <span className="search-box--small" style={{ width: 'auto' }}>
          <FormikInputField
            disabled={isDisabled}
            formikKey={payloadValue}
            name={payloadValue}
            onKeyPress={onKeyPress}
            placeholder={displayValue}
            title={displayValue}
            type="text"
          />
        </span>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
